// extracted by mini-css-extract-plugin
module.exports = {"edit_form":"EditDatasource_edit_form__30ug1"};